import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when any dynamic form successfully submitted.
 * @memberOf Playtech.API.events
 * @event dynamic-form-submitted
 * @type {callback}
 * @param {Object} details
 * @param {string} details.formName contains form name that was picked in component settings
 * @example Playtech.on('dynamic-form-submitted', ({ formName }) => {
 *    if (formName === '2fa') {
 *       // do something
 *   }
 * });
 */
export const DYNAMIC_FORM_SUBMITTED = 'dynamic-form-submitted';

export const useOnDynamicFormSubmitted = (eventTarget: EventTarget): void => {
    const triggerEvent = useCallback((detail: { formName: string }) => {
        const event = new CustomEvent(DYNAMIC_FORM_SUBMITTED, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(DYNAMIC_FORM_SUBMITTED, triggerEvent);

        return () => {
            publicEventsAPIService.off(DYNAMIC_FORM_SUBMITTED, triggerEvent);
        };
    }, [triggerEvent]);
};
